module.exports = __webpack_public_path__ + "img/Architecture.28f3f9e0.svg";